<template>
  <v-speed-dial
    v-model="fab"
    bottom
    right
    fixed

    direction="top"
    transition="scale-transition"
  >
    <template v-slot:activator>
      <v-btn
        v-model="fab"
        color="blue darken-2"
        dark
        fab
      >
        <v-icon>group_work</v-icon>
        <v-icon>close</v-icon>
      </v-btn>
    </template>
    <slot />
  </v-speed-dial>
</template>

<script>
export default {
  data() {
    return {
      fab: false
    };
  }
};
</script>

<style>
</style>
